var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4703 12.602L12.4707 12.6016C12.5443 12.5257 12.5424 12.4044 12.4665 12.3307C12.3905 12.257 12.2692 12.2588 12.1955 12.3347C12.1218 12.4106 12.1235 12.5319 12.1994 12.6057C12.2752 12.6794 12.3965 12.6778 12.4703 12.602",
    stroke: "#00A97C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14.0978C3.32175 14.0483 3.64669 14.0223 3.97222 14.02Lnan nanLnan nanL3.97222 14.02C5.77717 14.02 7.50819 14.737 8.78447 16.0133C10.0608 17.2896 10.7778 19.0206 10.7778 20.8256C10.7748 21.1511 10.7488 21.476 10.7 21.7978",
    stroke: "#00A97C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7.79785,
    width: 14,
    height: 14,
    rx: 1.5,
    stroke: "#00A97C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 7.79785V6.79785C5.99902 5.141 7.34217 3.79785 8.99902 3.79785H17.999C19.6559 3.79785 20.999 5.141 20.999 6.79785V15.7979C20.999 17.4547 19.6559 18.7979 17.999 18.7979H16.999",
    stroke: "#00A97C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/Images.e88317ee972faa736aa7428a92600ad5.svg";
export { ForwardRef as ReactComponent };